var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 36.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.47,38.12H7a2.19,2.19,0,0,1-2.18-2.18V20.71H1.07A1.08,1.08,0,0,1,0,19.61a1,1,0,0,1,.36-.79L18.54,2.44a2.2,2.2,0,0,1,2.92,0L39.64,18.82a1.08,1.08,0,0,1-.71,1.89h-3.7V35.94a2.19,2.19,0,0,1-2.18,2.18H26.53a2.18,2.18,0,0,1-2.18-2.18V25.06h-8.7V35.94A2.18,2.18,0,0,1,13.47,38.12Z",
    transform: "translate(0 -1.88)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIcon);
export default __webpack_public_path__ + "static/media/home_menu_icon.c061e028.svg";
export { ForwardRef as ReactComponent };